<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="个人信息" />
    </van-sticky>
    <div class="block">
      <!-- 当前信息 -->
      <div class="font-bigger">当前信息</div>
      <van-form class="mt10">
        <van-field
          disabled
          v-model="userInfo.name"
          label="姓名"
        />
        <van-field
          disabled
          v-model="userInfo.tel"
          label="手机号"
        />
        <van-field
          disabled
          label="微信授权"
          :placeholder="userInfo.wxOpenId ? '已绑定' : '未绑定'"
        >
          <template #button>
            <van-button v-if="!userInfo.wxOpenId" size="small" type="primary" @click="bindWx">绑定微信</van-button>
          </template>
        </van-field>
      </van-form>
      <!-- 修改信息 -->
      <div class="font-bigger mt40">修改信息</div>
      <!-- 个人信息组件 -->
      <UserInfoForm class="mt10" ref="UserInfoForm" :data="formData" @submit="onSubmit" />
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import Filter from "../../../utils/filter"
import { wechatAuth } from '../../../api/login'
import { fetchUserInfo, updateUserInfo } from '../../../api/user'
import UserInfoForm from '@/components/UserInfo'
export default {
  data() {
    return {
      customFieldName: {
        text: 'name'
      },
      userInfo: {},
      formData: {}
    };
  },
  components: {
    UserInfoForm
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    bindWx() {
      wechatAuth('bind').then(res => {
        window.location.href = res
      })
    },
    onClickLeft() {
      history.back()
    },
    onSubmit(data) {
      console.info(data)
      updateUserInfo(data).then(() => {
        Toast('修改成功')
        this.init()
      })
    },
    onConfirmFetus(val) {
      this.formData.type = val
      this.showPickerFetus = false
    },
    onConfirmState(val) {
      this.formData.state = val
      this.showPickerState = false
    },
    onConfirmBirth(val) {
      this.formData.birth = Filter.formatDateTime(val)
      this.showPickerBirth = false
    },
    fillData(res) {
      this.formData = res
      if (!res.state) {
        this.formData.state = {}
      }
      if (!res.type) {
        this.formData.type = {}
      }
      if (!res.sex) {
        this.formData.sex = {}
      }
      Object.assign(this.userInfo, res)
    },
    async init() {
      await fetchUserInfo().then(res => {
        this.fillData(res)
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.block {
  margin-top: 40px;
  padding: 0 40px;
}
</style>